import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

export function useGenerateServiceRequestFromPmTaskEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.GenerateServiceRequestFromPreventiveMaintenanceTask,
    false
  );

  return Boolean(isEnabled);
}
